import {
  ClippingStudioTextTemplate,
  ClippingStudioTextTemplateWritePayload,
} from "./clipping-studio-text-template";

/**
 * Provides text templates for the Clipping Studio Text panel catalog.
 */
export abstract class ITextTemplatesProvider {
  abstract getTextTemplates(): Promise<ClippingStudioTextTemplate[]>;

  /** Create a catalog template from editor styles. */
  abstract createTextTemplate(
    payload: ClippingStudioTextTemplateWritePayload,
  ): Promise<void>;

  /** Update an existing catalog template by id. */
  abstract updateTextTemplate(
    id: number,
    payload: ClippingStudioTextTemplateWritePayload,
  ): Promise<void>;

  /** Delete a catalog template by id. */
  abstract deleteTextTemplate(id: number): Promise<void>;
}
